export enum CenterAliasLinkType {
    Profile = 0,
    Directory = 1
}

interface IProps {
    centerId: number,
    centerAlias: string,
    rdnCenterId?: number,
    rdnCenterAlias?: string,
    currentCenter: number,
    isCenterLogin?: boolean,
    readOnly?: boolean
}

const CenterAlias = (props: IProps) => {
    if (props.readOnly) {
        return (
            <>
                {props.centerAlias}
                {props.rdnCenterId > 0 && (
                    <> <span style={{ color: 'red' }}>({props.rdnCenterAlias})</span></>
                )}
            </>
        );
    }

    if (props.rdnCenterId != null && props.rdnCenterId > 0) {
        if (props.centerId == props.currentCenter) {
            return (
                <><a href={`center/${props.currentCenter}/profile/edit`} target='_blank'>{props.centerAlias}</a> <span style={{ color: 'red' }}>({props.rdnCenterAlias})</span></>
            );
        }

        if (props.rdnCenterId == props.currentCenter) {
            return (
                <>{props.centerAlias} <span style={{ color: 'red' }}>(<a href={`center/${props.currentCenter}/profile/edit`} style={{ color: 'red' }} target='_blank'>{props.rdnCenterAlias}</a>)</span></>
            );
        }

        return (
            <>{props.centerAlias} <span style={{ color: 'red' }}>({props.rdnCenterAlias})</span></>
        );
    }


    if (props.centerId == props.currentCenter) {
        return (
            <a href={`center/${props.currentCenter}/profile/edit`} target='_blank'>{props.centerAlias}</a>
        );
    }

    if (!props.isCenterLogin) {
        return (
            <a href={`/center/${props.currentCenter}/reports/all-centers/details/${props.centerId}`} target='_blank'>{props.centerAlias}</a>
        );
    }

    return (
        <a href={`/center/${props.currentCenter}/reports/all-centers/details/${props.centerId}`} target='_blank'>{props.centerAlias}</a>
    );


};

export default CenterAlias;